import { useEffect, useState } from "react";

import { Alert, Button, Modal, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { useQueryClient } from "@tanstack/react-query";

import eye from "@/assets/svg/eye.svg";
import { ButtonFile } from "@/common/components/ButtonFile.tsx";
import ServiceTypeComponent from "@/common/components/ServiceTypeComponent.tsx";
import { DataDwellingInfos } from "@/modules/dwelling/interfaces";
import { IFile } from "@/modules/serviceOrdering/reducers";

export const DwellingCostingsModal = () => {
  const { id } = useParams<any>();
  const [open, setOpen] = useState(false);
  const [costingFiles, setCostingFiles] = useState<IFile[] | null>(null);

  const queryClient = useQueryClient();
  const queryCache = queryClient.getQueryCache();

  const getFileName = (path: string) => {
    const pathSplit = path.split("/");
    return pathSplit[pathSplit.length - 1];
  };

  useEffect(() => {
    if (open && !costingFiles) {
      const queryInfos = queryCache.find(["dwelling", "infos", id]);
      if (queryInfos?.state.data) {
        const dwellingsInfos = queryInfos.state.data as DataDwellingInfos;
        if (dwellingsInfos.files) {
          const files = dwellingsInfos.files.filter(
            (file) => file.type.value === "COST",
          );
          setCostingFiles(files);
        }
      }
    }
  }, [costingFiles, id, open, queryCache]);

  return (
    <>
      <Button
        className="btn dwelling_property-button_edit"
        variant="light"
        onClick={() => setOpen(true)}
      >
        <img src={eye} alt="eye" />
      </Button>
      <Modal
        size={"lg"}
        onHide={() => setOpen(false)}
        show={open}
        centered={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Chiffrages</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {costingFiles && costingFiles.length > 0 ? (
            <Table>
              <tbody>
                {costingFiles.map((file) => (
                  <tr key={file.id}>
                    <td className="text-center">
                      <ServiceTypeComponent label={file.type.label} />
                    </td>
                    <td className="text-center dark-purple-text">
                      {getFileName(file.path)}
                    </td>
                    <td className="text-center dark-purple-text">
                      <ButtonFile path={file.path} label="Voir le document" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <Alert variant="warning">Aucun chiffrage disponible</Alert>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
